interface QueryObject {
  [a: string]: string
}

export function parseQuery(queryStr = ''): QueryObject {
  const searchParams = new URLSearchParams(queryStr)

  const queryObject: QueryObject = {}
  searchParams.forEach((value, key) => {
    queryObject[key] = value
  })

  return queryObject
}
